import { memo } from 'react';
import { Divider, Flex, Text, Box } from '@cad-arc';
import RapidSOSIcon from '../../../../esri/images/phone-icons/unselected/RapidSOS_unselected.svg';
import {
    CommonSize,
    formatHoursMinutesSeconds,
    formatMonthDayYearHoursMinutes,
} from '../../../../common/helpers/utils';
import { eventNotificationPriorityToColors } from '../../../../event-notifications/event-notifications';
import { CloseMapLedgerAndClearSelectedEntityButton } from '../close-map-ledger-and-clear-selected-entity-button';

export const AmlCallOverview = memo(function AmlCallOverview({
    label,
    createdDateUtc,
    lastUpdated,
    amlCallHasGpsNotification,
    size,
}: {
    label?: string;
    createdDateUtc?: number;
    lastUpdated?: string;
    amlCallHasGpsNotification: boolean;
    size?: CommonSize;
}): React.ReactElement {
    const blockBorderBottomColor = amlCallHasGpsNotification
        ? eventNotificationPriorityToColors['STANDARD'].notchOrText
        : 'transparent';

    return (
        <Box
            data-testid="AML_CALL_OVERVIEW_SECTION"
            borderBottomWidth="2px"
            borderBottomColor={blockBorderBottomColor}
        >
            <Box padding="12px 18px">
                <Flex alignItems="center" justifyContent="space-between">
                    <Flex gap={2} alignItems="center">
                        <Flex alignItems="center" w={40}>
                            <img src={RapidSOSIcon} alt="icon" />
                        </Flex>
                        <Text fontSize={size} fontWeight="bold" style={{ wordBreak: 'break-word' }}>
                            {label}
                        </Text>
                        <Text>{formatMonthDayYearHoursMinutes(createdDateUtc!)}</Text>
                    </Flex>
                    <CloseMapLedgerAndClearSelectedEntityButton />
                </Flex>
                {lastUpdated && (
                    <Box paddingLeft="18px">
                        <Text fontSize={size} isItalic>
                            Location last updated {formatHoursMinutesSeconds(lastUpdated)}
                        </Text>
                    </Box>
                )}
            </Box>
            {!amlCallHasGpsNotification && <Divider />}
        </Box>
    );
});
